import React, { useState, useEffect } from 'react';
import { EnquiryForm } from '../types';
import { apiService } from '../services/api';

const Enquiry: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  const [enquiryForm, setEnquiryForm] = useState<EnquiryForm>({
    CompanyName: '',
    contact_person: '',
    Address: '',
    country: '',
    telNo: '',
    from: '',
    requirement_details: '',
    q: ''
  });
  const [captcha, setCaptcha] = useState('');

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = async () => {
    try {
      const response = await apiService.generateCaptcha();
      setCaptcha(response.captcha);
    } catch (error) {
      setCaptcha(Math.random().toString(36).substring(7));
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setEnquiryForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!enquiryForm.CompanyName) {
      alert('Please enter company name');
      return;
    }
    if (!enquiryForm.contact_person) {
      alert('Please enter contact person name');
      return;
    }
    if (!enquiryForm.Address) {
      alert('Please enter address');
      return;
    }
    if (!enquiryForm.country) {
      alert('Please select country');
      return;
    }
    if (!enquiryForm.telNo) {
      alert('Please enter telephone number');
      return;
    }
    if (!enquiryForm.from) {
      alert('Please enter email');
      return;
    }
    if (!enquiryForm.requirement_details) {
      alert('Please enter requirement details');
      return;
    }
    if (!enquiryForm.q) {
      alert('Please enter captcha code');
      return;
    }

    try {
      await apiService.submitEnquiry(enquiryForm);
      alert('Enquiry submitted successfully!');
      setEnquiryForm({
        CompanyName: '',
        contact_person: '',
        Address: '',
        country: '',
        telNo: '',
        from: '',
        requirement_details: '',
        q: ''
      });
      generateCaptcha();
    } catch (error) {
      alert('Error submitting enquiry. Please try again.');
    }
  };

  const handleReset = () => {
    setEnquiryForm({
      CompanyName: '',
      contact_person: '',
      Address: '',
      country: '',
      telNo: '',
      from: '',
      requirement_details: '',
      q: ''
    });
  };

  return (
    <main>
      {/* Breadcrumb Area */}
      <section className="breadcrumb-area d-flex align-items-center" style={{backgroundImage: 'url(/images/bg-img/bdrc-bg.jpg)'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Contact Us</h2>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Area */}
      <section id="contact" className="contact-area after-none contact-bg pt-50 pb-50 p-relative fix">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-8 order-1 m-auto">
              <div className="">
                <div className="section-title center-align mb-40 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                  <h2>Get In Touch</h2>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group has-feedback mt-3">
                    <label>Name of Company : <span>*</span></label>
                    <input 
                      type="text" 
                      className="form-control" 
                      name="CompanyName" 
                      value={enquiryForm.CompanyName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Name of Contact Person : <span>*</span></label>
                    <input 
                      type="text" 
                      className="form-control" 
                      name="contact_person" 
                      value={enquiryForm.contact_person}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Address / City / Location : <span>*</span></label>
                    <textarea 
                      className="form-control" 
                      rows={1} 
                      name="Address" 
                      value={enquiryForm.Address}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Country : <span>*</span></label>
                    <select 
                      name="country" 
                      className="form-control bg-white"
                      value={enquiryForm.country}
                      onChange={handleInputChange}
                    >
                      <option value="">Select a country</option>
                      <option value="India">India</option>
                      <option value="Other">Other</option>
                      <option value="Afghanistan">Afghanistan</option>
                      <option value="Albania">Albania</option>
                      <option value="Algeria">Algeria</option>
                      <option value="United States">United States</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Canada">Canada</option>
                      <option value="Australia">Australia</option>
                      <option value="Germany">Germany</option>
                      <option value="France">France</option>
                      <option value="Japan">Japan</option>
                      <option value="China">China</option>
                      <option value="Brazil">Brazil</option>
                      <option value="Russia">Russia</option>
                    </select>
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Tel. No. / Mobile No. : <span>*</span></label>
                    <input 
                      type="text" 
                      className="form-control" 
                      name="telNo" 
                      value={enquiryForm.telNo}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Email <span>*</span></label>
                    <input 
                      type="email" 
                      className="form-control" 
                      name="from" 
                      value={enquiryForm.from}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Requirement Details : <span>*</span></label>
                    <textarea 
                      className="form-control" 
                      rows={1} 
                      name="requirement_details" 
                      value={enquiryForm.requirement_details}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>

                  <div className="form-group has-feedback mt-3">
                    <label>Please Enter Verification Code in the box : <span>*</span></label>
                    <div style={{background: '#f0f0f0', padding: '10px', marginBottom: '10px', fontWeight: 'bold'}}>
                      {captcha}
                    </div>
                    <input 
                      type="text" 
                      name="q" 
                      className="form-control input"
                      value={enquiryForm.q}
                      onChange={handleInputChange}
                    />
                  </div>

                  <p className="text-center">
                    <button type="submit" className="mt-5 btn btn-secondary me-3">Submit</button>
                    <button type="button" onClick={handleReset} className="mt-5 btn btn-secondary">Reset</button>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Enquiry;